<template>
    <div
        v-if="news"
        class="tw-flex tw-flex-row tw-items-start tw-gap-4 tw-cursor-pointer"
        @click="openNews">
        <img
            alt=""
            class="tw-aspect-[144/158] tw-w-32 tw-rounded-xl tw-object-cover tw-object-center xl:tw-rounded-3xl"
            :class="showDescription ? 'tw-w-36' : 'tw-w-32'"
            :src="news.getImage('medium')" />
        <div>
            <p class="tw-mb-3 tw-text-sm tw-font-normal tw-text-dark xl:tw-text-base">{{ news.getPublishDate() }}</p>
            <h4
                class="tw-line-clamp-2 tw-text-base tw-font-semibold xl:tw-text-lg"
                :class="showDescription ? 'tw-line-clamp-2' : 'tw-line-clamp-3'"
                v-html="news.title"></h4>
            <p v-if="showDescription" class="tw-mt-2 tw-text-sm tw-font-normal tw-text-dark tw-line-clamp-2" v-html="news.description"></p>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { News, useNews } from '@/composables/useNews';

    const props = defineProps<{
        news: News;
        showDescription?: boolean;
    }>();

    const news = computed(() => {
        return props.news ? useNews(props.news) : null;
    });

    const $router = useRouter();
    const openNews = () => {
        $router.push({ name: 'NewsDetail', params: { documentId: news.value?.slug as string } });
    };
</script>

<style scoped></style>
